import moment from "moment";
import 'moment/locale/uk';

export class EmergencyHelper {
    static prettifyDate(date) {
        return moment(new Date(date)).format('LLL')
    }
    static arrangeEmergencyFields(emergency) {
        return {
            id: emergency.id,
            phone: emergency.user.phone,
            datetime: emergency.datetime || EmergencyHelper.prettifyDate(emergency.createdAt),
            state: emergency.state,
            latitude: emergency.latitude,
            longitude: emergency.longitude,
            ...emergency,
            finishedAt: emergency.finishedAt && EmergencyHelper.prettifyDate(emergency.finishedAt)
        };
    }
}
